import React, { useContext, useEffect } from 'react';
import QuotePostLineContext from './QuotePostLineContext';

const QuotePostLineSecondary = ({ children }) => {
  const { showDetails, setHasSecondary } = useContext(QuotePostLineContext);

  useEffect(() => {
    setHasSecondary(true);
  }, []);

  if (!showDetails) {
    return null;
  }

  return <div className="quote-mapping-details">{children}</div>;
};

export default QuotePostLineSecondary;
